api = require('./0_def.coffee')

api.factory 'api/Appointment#record', [
  'ksc.EditableRecord',
  (EditableRecord) ->
    class Appointment extends EditableRecord
      _name: =>
        inf = @patientSummary
        inf.lastName + ', ' + inf.firstName +
          if (m = inf.middleName) then ' ' + m else ''


      __cachedTimes: null
      _cacheTime: (key, t, parser = moment) =>
        cache = ((@__cachedTimes ?= {})[key] ?= { t, parser })
        unless cache.v and cache.t is t and cache.parser is parser
          cache.t = t
          cache.parser = parser
          cache.v = parser t
        cache.v

      _ageHuman: (key) =>
        moment.duration(@[key] - (new Date).getTime()).humanize true

      _timeHuman: (key, parser) =>
        @_cacheTime(key, @[key], parser)?.format 'M/D [at] h:mma'
]


api.factory 'api/Appointment#factory', [
  'api/Appointment#record', 'ksc.RestList',
  (AppointmentRecord, RestList) ->

# KSC does not support array types properly (e.g. for contracts) yet.
# TODO: start using contracts as array support is released
    contract = null
    #     contract =
    #       appointmentId:       {type: 'number'}
    #       occurrenceId:        {type: 'number', nullable: true}
    #       appointmentUUID:     {type: 'string'}
    #       appointmentReasonId: {type: 'number'}
    #       appointmentStatus:   {type: 'number'}
    #       appointmentType:     {type: 'number'}
    #       notes:               {type: 'string', nullable: true}
    #       providerId:          {type: 'number', nullable: true}
    #       recurring:           {type: 'boolean'}
    #       resourceId:          {type: 'number', nullable: true}
    #       resourceIds:         {type: 'array'}
    #       serviceLocationId:   {type: 'number'}
    #       startTime:           {type: 'number'}
    #       endTime:             {type: 'number'}
    #       createdDate:         {type: 'number', nullable: true}
    #       patientSummary: contract:
    #         patientId:          {type: 'number'}
    #         genderId:           {type: 'number'}
    #         dateOfBirth:        {type: 'number'}
    #         firstName:          {type: 'string'}
    #         middleName:         {type: 'string', nullable: true}
    #         lastName:           {type: 'string'}
    #         preferredEmailType: {type: 'string', nullable: true}
    #         email:              {type: 'string', nullable: true}
    #         workEmail:          {type: 'string', nullable: true}
    #         otherEmail:         {type: 'string', nullable: true}
    #         preferredPhoneType: {type: 'string', nullable: true}
    #         homePhone:          {type: 'string', nullable: true}
    #         mobilePhone:        {type: 'string', nullable: true}
    #         workPhone:          {type: 'string', nullable: true}
    #         otherPhone:         {type: 'string', nullable: true}
    #       recurrenceRule: contract:
    #         recurrenceRuleId:             {type: 'number'}
    #         startDate:                    {type: 'number'}
    #         endDate:                      {type: 'number', nullable: true}
    #         numOccurrences:               {type: 'number', nullable: true}
    #         dayInterval:                  {type: 'number', nullable: true}
    #         monthInterval:                {type: 'number', nullable: true}
    #         monthOfYear:                  {type: 'number', nullable: true}
    #         dayOfMonth:                   {type: 'number', nullable: true}
    #         typeOfDay:                    {type: 'number', nullable: true}
    #         dayOfWeekMonthlyOrdinal:      {type: 'number', nullable: true}
    #         dayOfWeekMonthlyOrdinalFlags: {type: 'number', nullable: true}
    #         typeOfDayMonthlyOrdinal:      {type: 'number', nullable: true}
    #         typeOfDayMonthlyOrdinalFlags: {type: 'number', nullable: true}
    #         dayOfWeek:                    {type: 'array', nullable: true}
    #         dayOfWeekFlags:               {type: 'number', nullable: true}
    #         numberOfTimes:                {type: 'number', nullable: true}

    ->
      new RestList
# cache: true # TODO: ksc may provide range cache later
        endpoint:
          responseProperty: 'results'
          url: '/dashboard-calendar-ui/api/Appointment'
        record:
          class: AppointmentRecord
#           contract:   contract
          idProperty: ['appointmentId', 'occurrenceId']
          url: '/dashboard-calendar-ui/api/Appointment/<id>'
]


api.service 'api/Appointment', [
  'api/Appointment#factory',
  (appointmentsFactory) ->

# NOTE: It is the caller's responsbility to load this service with data
# parts and filter the results as needed (i.e. there may be multiple widgets
# using different parst of the data set)
# Do not ever treat this service as a container for your data only. If you
# want independently loaded data store, use the factory and instanciate
# your own.
    appointmentsFactory()
]
